module.exports = __webpack_public_path__ + "img/cb4-2-r-y1.5b83d0a8.gif";